import Class from './c-loading';
import './c-loading@';

export default Class;